import { appSlice } from '../slices/app.slice';

export const { setNetwork, setNetworkInfo } = appSlice.actions;
